export enum chartViewTypes {
  taskCount = 'task_count',
  timeEstimate = 'time_estimate',
  sprintPoint = 'sprint_point'
}